const applyMiddleware = (middleware = []) => fetch => {
  return middleware.reduce(
    (fetchFunc, middlewareFunc) => middlewareFunc(fetchFunc),
    fetch
  );
};

export default applyMiddleware;
